/* Jump About: show the price beside each Hire Duration option in the
   BookThatApp popup, display-only. Variant names stay clean so no price
   text leaks into cart or checkout line items.
   v2: derive the base title from the CURRENT text every pass (strip our
   own suffix, never cache) so BTA's own selection changes always win. */
(function () {
  if (!/\/products\//.test(window.location.pathname)) return;

  var variantPrices = null; // map: option title -> "$220"
  var SUFFIX_RE = /\s–\s\$[\d.,]+$/; // " - $220" (en dash)

  function loadVariants() {
    var handle = window.location.pathname.split('/products/')[1].split(/[?#/]/)[0];
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var map = {};
        (p.variants || []).forEach(function (v) {
          var dollars = v.price / 100;
          var label = dollars % 1 === 0 ? '$' + dollars : '$' + dollars.toFixed(2);
          map[v.title] = label;
          if (v.option1) map[v.option1] = label;
        });
        return map;
      });
  }

  function applySuffix(el) {
    var current = el.textContent.trim();
    var base = current.replace(SUFFIX_RE, '');
    var price = variantPrices[base];
    if (!price) return;
    var want = base + ' – ' + price;
    if (current !== want) el.textContent = want;
  }

  function decorate(doc) {
    if (!variantPrices) return;
    doc.querySelectorAll('.bta-react-select__option, .bta-react-select__single-value')
      .forEach(applySuffix);
  }

  function watchIframe(iframe) {
    var doc;
    try { doc = iframe.contentDocument; } catch (e) { return; }
    if (!doc || !doc.body) return;
    if (doc.body.getAttribute('data-ja-price-watch') === '1') return;
    doc.body.setAttribute('data-ja-price-watch', '1');
    var obs = new MutationObserver(function () { decorate(doc); });
    obs.observe(doc.body, { childList: true, subtree: true, characterData: true });
    decorate(doc);
  }

  function scan() {
    document.querySelectorAll('#bta-widget-container iframe, #bta-product-widget iframe').forEach(watchIframe);
  }

  loadVariants().then(function (map) {
    variantPrices = map;
    scan();
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  }).catch(function () { /* leave dropdown untouched on failure */ });
})();
